/**
 * @prop --background-color: Background color of toast
 */

:host {
  pointer-events: all;

  --label-font-family: #{$toastLabelFontFamily};
  --label-font-weight: #{$toastLabelFontWeight};
  --label-font-style: #{$toastLabelFontStyle};

  --label-color: #{$toastLabelColor};
  --background-color: #{$toastBackgroundColor};
  --close-color: #{$toastCloseColor};
  --button-color: #{$toastButtonColor};
  --icon-color: #{$toastIconColor};
}

:host([type="success"]) {
  --icon-color: #{$toastSuccessIconColor};
}

:host([type="warning"]) {
  --icon-color: #{$toastWarningIconColor};
}

:host([type="error"]) {
  --icon-color: #{$toastErrorIconColor};
}

.stzh-toast {
  position: relative;
  display: flex;
  box-shadow: $boxShadowMessage;
  background-color: var(--background-color);
  border-radius: #{$buttonBorderRadius};
  transition: background-color $baseTransitionAnimationSpeed;

  @include highContrast() {
    border: 1px solid Highlight;
  }

  &__content {
    flex-grow: 1;
    display: flex;
    gap: space('small');
    padding: space('medium');
  }

  &__icon-wrapper {
    flex-shrink: 0;
    display: flex;
  }

  &__icon {
    color: var(--icon-color);
  }

  &__text-wrapper {
    flex-grow: 1;
  }

  &__label {
    @include fontSize('milli');
    color: var(--label-color);
    font-family: var(--label-font-family);
    font-weight: var(--label-font-weight);
    font-style: var(--label-font-style);
    transition: color $baseTransitionAnimationSpeed;
    padding-right: space('xxlarge');

    @include mq($from: small) {
      padding-right: space('xxxlarge');
    }
  }

  &__close-wrapper {
    flex-shrink: 0;
  }

  &__link {
    --stzh-button-tertiary-color: var(--button-color);
  
    display: flex;
    justify-content: flex-end;
  }

  &__close[variant="tertiary"] {
    --color: var(--close-color);

    position: absolute;
    top: 0;
    right: 0;
  }

  /* Has link */

  &--has-link &__label:not(:empty) + &__link {
    margin-top: space('xsmall');
  }
}
